import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__SET_FHETICKETS`:
            return core.setFheTicket(state, action.tickets);
        case `${env.toUpperCase()}__SET_FHETICKET_DETAILS`:
            return core.setFheTicketDetails(state, action.ticketId, action.ticket);
        case `${env.toUpperCase()}__UPDATE_FHETICKET_STATE`:
            return core.updateFheTicketState(state, action.ticketId, action.ticketState);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/TicketFhe/reducer.js